/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PasswordSetChallengeOptions } from './PasswordSetChallengeOptions';
import {
    PasswordSetChallengeOptionsFromJSON,
    PasswordSetChallengeOptionsFromJSONTyped,
    PasswordSetChallengeOptionsToJSON,
} from './PasswordSetChallengeOptions';

/**
 * 
 * @export
 * @interface PasswordSetChallenge
 */
export interface PasswordSetChallenge {
    /**
     * 
     * @type {string}
     * @memberof PasswordSetChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordSetChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordSetChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {PasswordSetChallengeOptions}
     * @memberof PasswordSetChallenge
     */
    options: PasswordSetChallengeOptions;
}

/**
 * Check if a given object implements the PasswordSetChallenge interface.
 */
export function instanceOfPasswordSetChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function PasswordSetChallengeFromJSON(json: any): PasswordSetChallenge {
    return PasswordSetChallengeFromJSONTyped(json, false);
}

export function PasswordSetChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': PasswordSetChallengeOptionsFromJSON(json['options']),
    };
}

export function PasswordSetChallengeToJSON(value?: PasswordSetChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': PasswordSetChallengeOptionsToJSON(value.options),
    };
}

